import { render, staticRenderFns } from "./externalmanagement.vue?vue&type=template&id=2e5a0a84"
import script from "./externalmanagement.vue?vue&type=script&lang=js"
export * from "./externalmanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5a0a84')) {
      api.createRecord('2e5a0a84', component.options)
    } else {
      api.reload('2e5a0a84', component.options)
    }
    module.hot.accept("./externalmanagement.vue?vue&type=template&id=2e5a0a84", function () {
      api.rerender('2e5a0a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/externalmanagement.vue"
export default component.exports